import React from "react";
import { useSelector } from "react-redux";
import { AddParticiapantsHoc, ClearChatHoc, DeleteHoc, IconExitGroupHoc, IconGroupReportHoc } from "../../../assets/images";
import { isLocalUser } from "../../../Helpers/Chat/User";
import ChatMuteOption from "./ChatMuteOption";
import Participants from "./Participants";

const ClearDeleteOption = (props = {}) => {
  const {
    isAdmin,
    vCardData,
    groupuniqueId,
    participants = [],
    ClearPopupAction,
    deletePopupAction,
    dispatchExitAction,
    handleChatMuteAction,
    // contactPermission,
    reportGroupChatAction = () => { }
  } = props;

  const globalState = useSelector(state => state);  
  const { featureFlagList: { data: { isClearChatEnabled = false, isDeleteChatEnabled = false }} = {} } = globalState;
  const handleNewParticipants = () => {
    props.handleNewParticipants();
  }

  let exitGroup = !participants.find(users => isLocalUser(users.userId));
  const { data: [{ chatId = "", recent: { muteStatus = 0 } = {} }] = {} } = useSelector((store) => store.activeChatData) || {};

  return (
    <React.Fragment>
      <div className="contactinfo-about-no action">
        {!exitGroup &&
          <>
            {/* {(archiveStatus !== 1 || !isPermanentArchvie) ? */}
              <ChatMuteOption
                chatId={chatId}
                isChatMute={muteStatus === 1}
                handleChatMuteAction={handleChatMuteAction}
              />
              {/* :
              <div className="text-disbaled">
                <BlockedInfo />
                <span>Archived chats are muted</span>
              </div>
            } */}
          </>
        }
      </div>
      <div className="contactinfo-media group-members">
        <h5>
          <span className="media">Participants</span>
          <span className="count">{participants.length}</span>
        </h5>
        <ul>
          {isAdmin && (<>
            <li className="addMembers" onClick={handleNewParticipants} data-jest-id={"jesthandleNewParticipants"}>
              <div className="user-profile-name">
                <div className="profile-image">
                  <AddParticiapantsHoc viewBox="0 0 19.783 16.302" />
                </div>
                <div className="profile-name">
                  <span>
                    <h3>Add Participants</h3>
                  </span>
                </div>
              </div>
            </li>
          </>
          )}
          {participants.map((members) => {
              return (
                <Participants
                  key={members.userId}
                  members={members}
                  isAdmin={isAdmin}
                  groupuniqueId={groupuniqueId}
                  vCardData={vCardData}
                />
              );
            })
          }
        </ul>
        <div className="contactinfo-about-no action">
          {isClearChatEnabled && (
            <div className="about-no" onClick={ClearPopupAction} data-jest-id={"jestClearPopupAction"}>
              <i className="deleteIcon">
              <ClearChatHoc viewBox="0 0 18 18"/>
              </i>
              <span className="delete">{"Clear Chat"}</span>
            </div>)
          }
          {!exitGroup ? (
            <div className="about-no grp-exit" onClick={dispatchExitAction} data-jest-id={"jestdispatchExitAction"}>
              <i>
                <IconExitGroupHoc viewBox="0 0 18 18"/>
              </i>
              <span className="delete">Exit Group</span>
            </div>
          ) : 
          (isDeleteChatEnabled && <div className="about-no" data-jest-id={"jestdeletePopupAction"} onClick={deletePopupAction}>
              <i className="deleteIcon">
                <DeleteHoc viewBox="0 0 18.2 18.201"/>
              </i>
              <span className="delete">{"Delete Group"}</span>
            </div>
          )
          }          
          <div data-jest-id={"jestGroupReportAction"} className="about-no" onClick={reportGroupChatAction}>
            <i className="reportIcon">
              <IconGroupReportHoc viewBox="0 0 14 14"/>
            </i>
            <span className="report">{"Report Group"}</span>
          </div>
        </div> 
      </div>
    </React.Fragment>
  );
};

export default ClearDeleteOption;
